import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
Vue.prototype.$store = store

import mix from './api/mix'
Vue.mixin(mix)
import test from './api/regular'
Vue.prototype.$test = test



import mobileTipjs from '@/views/components/tip/tip.js'
Vue.prototype.$tips = mobileTipjs
import request from '@/api/request'
Vue.use(request);
// 引入jQuery、bootstrap
import $ from 'jquery'
import 'bootstrap'
// 引入bootstrap样式
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
// 全局注册 $
Vue.prototype.$ = $

import VueI18n from "vue-i18n"
Vue.use(VueI18n)
import zh from './locales/zh.js'
import en from './locales/en.js'
const i18n = new VueI18n({
    locale: (function() {
        if (localStorage.getItem('lang')) {

            return localStorage.getItem('lang')
        } else {
            localStorage.setItem('lang', 'zh')
            return 'zh'
        }

    }()),
    messages: {
        'en': en, //英文语言包
        'zh': zh, //中文繁体包
    }
})

Vue.prototype._i18n = i18n

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
// import {
//     Message
// } from 'element-ui';
Vue.prototype.$message = ElementUI.Message
    // import animated from "animate.css"
    // Vue.use(animated)
import 'normalize.css/normalize.css'
import '@/assets/css/reset.css'
import '@/assets/css/index.css'

Vue.config.productionTip = false

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')